import React, { useState, useEffect } from "react";
import NavBar from "./components/NavBar";
import HomePage from "./components/HomePage";
import MembersPage from "./components/MembersPage";
import { ThemeProvider, useTheme } from "./components/ThemeContext";
import ActivityPage from "./components/ActivityPage";
import lightBG from "../assets/lightBG.png";
import darkBG from "../assets/darkBG.png";
import { ToastContainer, toast } from "react-toastify";
import AuthPage from "./AuthPage";
import PunishmentsPage from "./components/PunishmentsPage";
import ChestPage from "./components/ChestPage";
import InfoPage from "./components/InfoPage";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";
import BonusPage from "./components/BonusPage";
import TestPage from "./components/TestPage";
import CvPage from "./components/CvPage";
import axios from "axios";

function MainPanel() {
  return (
    <ThemeProvider>
      <MainApp />
    </ThemeProvider>
  );
}

const MainApp = () => {
  const { theme } = useTheme();
  const [currentPage, setCurrentPage] = useState(() => {
    return localStorage.getItem("currentPage") || "home";
  });
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const text = urlParams.get("succesNotif");
    toast.success(text);
    if (!Cookies.get("accountCreated")) {
      navigate("/");
    }
  }, [navigate]);

  const logOut = async () => {
    try {
      await axios.post("http://panelmedici.fplayt.ro:5000/api/logout", {
        refreshToken: Cookies.get("refreshToken"),
      })
      Cookies.remove("accountCreated");
      navigate("/");
    } catch (err) {
      toast.error("A aparut o eroare! Nu ai fost delogat.")
      console.log(err);
    }
  }

  useEffect(() => {
    localStorage.setItem("currentPage", currentPage);

    if (!Cookies.get("accessToken")) {
      logOut();
    }
  }, [currentPage]);

  const renderPage = () => {
    switch (currentPage) {
      case "home":
        return <HomePage />;
      case "members":
        return <MembersPage />;
      case "activity":
        return <ActivityPage />;
      case "punishmentsList":
        return <PunishmentsPage />;
      case "treasury":
        return <ChestPage />;
      case "auth":
        return <AuthPage />;
      case "info":
        return <InfoPage />;
      case "bonus":
        return <BonusPage />;
      case "test":
        return <TestPage />;
      case "cvs":
        return <CvPage />;
      default:
        return <HomePage />;
    }
  };

  const appStyle: React.CSSProperties = {
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url(${theme === "light" ? lightBG : darkBG})`,
  };

  return (
    <div className={`${theme}`} style={appStyle}>
      {currentPage !== "logout" && currentPage !== "auth" && (
        <NavBar setCurrentPage={setCurrentPage} />
      )}
      {renderPage()}
      <span className="absolute w-full text-center textMedium text-black dark:text-white bottom-[0.07vw] text-[0.7vw]">
        Copyright 2025 - Bogdan &amp; Tristan
      </span>
      <ToastContainer />
    </div>
  );
};

export default MainPanel;
